import { Link } from 'react-router-dom';
import { SiteHeader } from '../components/SiteHeader';
import { SEO } from '../components/SEO';

/**
 * Catch-all 404 for any route the SPA router doesn't recognise.
 * noindex so Google doesn't log these as Soft 404s against the site.
 *
 * Note: Cloudflare Pages still serves this with HTTP 200 (SPA fallback),
 * but the noindex meta is the signal Google actually acts on for
 * client-rendered pages. The previous behaviour was that unmatched
 * routes fell through to <Landing /> → every unknown URL got the
 * homepage canonical, which is exactly what triggered the Soft 404
 * cluster in Search Console.
 */
export function NotFound() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <SEO title="Page not found — Dormant Accounts Filing" noindex />
      <SiteHeader />

      <main className="mx-auto max-w-xl px-6 py-20 text-center">
        <p className="text-sm font-medium text-brand-700">404</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">
          We couldn't find that page
        </h1>
        <p className="mt-4 text-slate-600">
          The link may be out of date, or the page may have moved. Here are the places you
          most likely wanted:
        </p>

        <div className="mt-8 flex flex-col items-center gap-3">
          <Link
            to="/search"
            className="inline-flex items-center justify-center rounded-md bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white shadow hover:bg-brand-700"
          >
            File dormant accounts
          </Link>
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-brand-700">
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/services" className="hover:underline">Services</Link>
            <Link to="/blog" className="hover:underline">Blog</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
